<template>
    <div>

        <div class="item" v-for="(supply, supplyIndex) in order.children" :key="supplyIndex">
        <div class="goodsImage">
            <img :src="supply.image_url || 'default-image.png'" alt="" />
        </div>
        <div class="otable">
            <div class="tableTitle">
                <div class="t1 bd">序号</div>
                <div class="t2 bd">产品名称</div>
                <div class="t2 bd">产品子类型</div>
                <div class="t4 bd">中英文不同，点击查看操作细则</div>
                <div class="t3 bd">产品名称</div>
            </div>
            <div class="otbody">
                <div class="tb1 bd">序号</div>
                <div class="tb2 bd">类型</div>
                <div class="tb2 bd">内容</div>
                <div class="tb1 bd">表面处理</div>
                <div class="tb1 bd">宽</div>
                <div class="tb1 bd">高</div>
                <div class="tb1 bd">单价(￥)</div>
                <div class="tb1 bd">套数</div>
                <div class="tb2 bd">小计(￥)</div>
            </div>
            
            <div v-for="(product, productIndex) in supply.children" :key="productIndex">
                <div class="otbody">
                    <div class="tb1 bd">{{productIndex + 1}}</div>
                    <div>
                        <div class="part1">
                            <div class="tb2 bd">{{product.name}}</div>
                            <div class="tb2 bd">{{product.sub_category_name}}</div>
                            <div class="tb1 bd">无</div>
                            <div class="tb1 bd">{{product.width}}mm</div>
                            <div class="tb1 bd">{{product.length}}mm</div>
                        </div>
                        <div class="" style="border-bottom: 1px solid #aaa;">
                            <div class="tb7 flx bright allheight">
                                <div class="quotationItem" v-for="(attr, attrIndex) in product.attr_info" :key="attrIndex">
                                    <div class="qname">
                                        <span style="color: red;">*</span>
                                        {{attr.name}}：
                                    </div>
                                    <div class="qselect">
                                        <div style="border: 1px solid #007fff;border-radius: 40px;text-align: center;line-height: 20px;padding: 5px;padding-left: 10px;padding-right: 10px;"    
                                        v-for="option in attr.childs" 
                                            :key="option.category_id" v-if="option.flag == true" >
                                            {{ option.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tb1 bd">{{product.price}}</div>
                    <div class="tb1 bd">
                        <input type="number" v-model="product.num" style="width: 80%;" />
                    </div>
                    <div class="tb2 bd">
                        {{product.total_price}}<i class="el-icon-delete" @click="delProduct(supplyIndex, productIndex)"></i>
                    </div>
                </div>
            </div>

            <!-- 小计 -->
            <div class="otbody">
                <div class="tb3 bd"></div>
                <div class="tb7 bd">小计</div>
                <div class="tb2 bd">{{calculateSupplySubtotal(supply)}}</div>
            </div>
        </div>
        
        <div class="otbody">
            <div class="tf flx spcenter">
                <el-button type="primary" @click="addProducts(order)">添加产品</el-button>

            </div>
        </div>
    </div>

    <div class="otable mp20" style="display: inline-block;">
        <div class="otbody">
            <div class="tb3 bd">以上合计</div>
            <div class="tb7 bd">大写：{{smallToBig(order.product_price)}}</div>
            <div class="tb2 bd">￥{{order.product_price}}</div>
        </div>

        <div class="otbody">
            <div class="tb3 bd">费用</div>
            <div class="tb7 bd">运费：{{order.express_price}}元</div>
            <div class="tb2 bd">￥{{order.express_price}}</div>
        </div>

        <div class="otbody" v-if="order.discount_price > 0">
            <div class="tb3 bd">优惠</div>
            <div class="tb7 bd">减{{order.discount_price}}元</div>
            <div class="tb2 bd">减{{order.discount_price}}元</div>
        </div>

        <div class="otbody" v-for="(promo, promoIndex) in order.save_full" :key="promoIndex">
            <div class="tb3 bd">满减活动</div>
            <div class="tb7 bd">{{promo.active_name}}</div>
            <div class="tb2 bd" v-if="promo.reduce_type === 1">
                减{{promo.reduce_value}}元
            </div>
            <div class="tb2 bd" v-if="promo.reduce_type === 2">
                打折{{promo.reduce_value}}%
            </div>
        </div>

        <div class="otbody">
            <div class="tb3 bd">应付</div>
            <div class="tb7 bd">大写：{{smallToBig(order.total_pay_price)}}</div>
            <div class="tb2 bd">￥{{order.total_pay_price}}</div>
        </div>
        
        <div class="otbody">
            <div class="tb3 bd">备注</div>
            <div class="tb9 bd">
                <el-input v-model="order.remark" placeholder="备注"></el-input>
            </div>
        </div>
    </div>
        <div class="setOrder">
            <el-button type="danger" @click="downloadAsWord">下载表单</el-button>
            <el-button type="danger" @click="createOrder">确认下单</el-button>
            
        </div>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <img :src="code_url" style="width: 100px;height: 100px;border-radius: 10px;">
            <span>订单是否已完成？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="testOrder">是</el-button>
                <el-button @click="dialogVisible = false">否</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import HproductApi from '@/api/hproduct.js'
    import HorderApi from "@/api/horder.js"
    import { Document, Paragraph, TextRun, HeadingLevel, Packer } from 'docx';
    import { saveAs } from 'file-saver';
    import { Table, TableRow, TableCell } from 'docx';
    
    export default {
        data() {
            return {
                array: [],
                options: [],
                value: '',
                cates: [],
                blank: [],
                totalPrice: "",
                yf: "",
                coupon: "",
                infext: "",
                remark: "",
                expressPrice:"",
                discount_price:"",
                pay_price:"",
                save_full:[],
                order:{},
                horder_id:0,
                dialogVisible:false,
                code_url:"",
            };
        },
        created() {
     
            this.horder_id = this.$route.query.order_id;
            this.orderDetail();
        },
        methods: {
            orderDetail(){
                var self = this;
                HorderApi.orderDetail({
                    horder_id: self.horder_id,
                }).then((res) => {
                    self.order = res.data;
                })
            },
            calculateSupplySubtotal(supply) {
                return supply.children.reduce((total, product) => {
                    return total + parseFloat(product.total_price || 0);
                }, 0);
            },
            smallToBig(num) {
        // Implement your number to Chinese words conversion here
        // Example implementation (you may need a more complete one)
        const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
        const units = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿'];
        const decimalUnits = ['角', '分'];
        
        let n = parseFloat(num || 0);
        let integer = Math.floor(n);
        let decimal = Math.round((n - integer) * 100);
        
        let result = '';
        
        // Convert integer part
        if (integer > 0) {
            let intStr = integer.toString();
            for (let i = 0; i < intStr.length; i++) {
                let digit = parseInt(intStr[i]);
                let unit = units[intStr.length - 1 - i];
                result += digits[digit] + unit;
            }
            result += '元';
        }
        
        // Convert decimal part
        if (decimal > 0) {
            let decStr = decimal.toString().padStart(2, '0');
            for (let i = 0; i < decStr.length; i++) {
                let digit = parseInt(decStr[i]);
                if (digit > 0) {
                    result += digits[digit] + decimalUnits[i];
                }
            }
        } else {
            result += '整';
        }
        
        return result || '零元整';
        },
        delProduct(supplyIndex, productIndex) {
            // Implement product deletion logic
            this.data.list.children[supplyIndex].children.splice(productIndex, 1);
        },
        addProducts(row) {
            var self = this;
                self.$router.push({
                    path: '/store/placeorder/index',
                    query: {
                        order_id: row.horder_id
                    }
                })   
        },
        getPrice() {
            // Implement price calculation logic
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
  
        // 检测订单
        testOrder(){
            var self = this;
            HorderApi.orderDetail({
                horder_id: self.horder_id,
            }).then((res) => {
                self.order = res.data;
                if(res.data.pay_status==1){
                    // 修改订单状态为已完成
                    HorderApi.edit({
                        horder_id: self.horder_id,
                        status:90,
                    }).then((result) => {
                        if(result.code==1){
                        localStorage.removeItem("select_product")
                            self.$message({
                                message: '订单已完成!',
                                type: 'success'
                            });
                            setTimeout(() => {
                                self.$router.go(-1)
                            }, 1000);
                        }
                    });
                }else{
                    self.$message({
                        message: '订单未支付无法完成订单!',
                        type: 'warning'
                    });
                }
            })
        },

        async downloadAsWord() {
    const doc = new Document({
      styles: {
        paragraphStyles: [
          {
            id: "normal",
            name: "Normal",
            run: {
              size: 24, // 12pt = 24 half-points
              font: "Microsoft YaHei"
            },
            paragraph: {
              spacing: { line: 276 } // 1.15行距
            }
          },
          {
            id: "heading1",
            name: "Heading 1",
            run: {
              size: 32,
              bold: true,
              color: "000000",
              font: "Microsoft YaHei"
            },
            paragraph: {
              spacing: { before: 400, after: 200 }
            }
          }
        ]
      },
      sections: [{
        properties: {},
        children: this.generateDocxContent()
      }]
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, '订单详情.docx');
  },

  generateDocxContent() {
    const content = [];
    
    content.push(new Paragraph({
      text: "订单详情",
      heading: HeadingLevel.HEADING_1,
      spacing: { after: 400 }
    }));

    // 2. 添加供应商信息
    this.order.children.forEach((supply, supplyIndex) => {
      content.push(new Paragraph({
        text: `订单 ${supplyIndex + 1}: ${supply.name}`,
        heading: HeadingLevel.HEADING_2,
        spacing: { before: 400, after: 200 }
      }));

      // 3. 添加产品表格
      const productRows = [];
      
      // 表头
      productRows.push(new Paragraph({
        children: [
          new TextRun({ text: "产品名称", bold: true, size: 28 }),
          new TextRun({ text: "\t类型", bold: true, size: 28 }),
          new TextRun({ text: "\t宽\t", bold: true, size: 28 }),
          new TextRun({ text: "\t高\t", bold: true, size: 28 }),
          new TextRun({ text: "\t单价", bold: true, size: 28 }),
          new TextRun({ text: "\t数量", bold: true, size: 28 }),
          new TextRun({ text: "\t小计", bold: true, size: 28 })
        ],
      }));

      // 产品数据
      supply.children.forEach((product, productIndex) => {
        productRows.push(new Paragraph({
          children: [
            new TextRun({ text: product.name, size: 24 }),
            new TextRun({ text: `\t${product.sub_category_name}`, size: 24 }),
            new TextRun({ text: `\t${product.width}mm`, size: 24 }),
            new TextRun({ text: `\t${product.length}mm`, size: 24  }),
            new TextRun({ text: `\t￥${product.price}`, size: 24 }),
            new TextRun({ text: `\t${product.num}`, size: 24 }),
            new TextRun({ text: `\t￥${product.total_price}`, size: 24 })
          ],
          spacing: { after: 100 }
        }));
      });

      content.push(...productRows);
    });

    // 4. 添加总计信息（带边框样式）
    content.push(new Paragraph({
      text: "订单总计",
      heading: HeadingLevel.HEADING_2,
      spacing: { before: 600 }
    }));

    content.push(new Paragraph({
      children: [
        new TextRun({ text: "产品总价:", bold: true, size: 24 }),
        new TextRun({ text: `\t￥${this.order.product_price}`, size: 24 })
      ],
      border: { bottom: { color: "AAAAAA", size: 6 } }
    }));

    content.push(new Paragraph({
      children: [
        new TextRun({ text: "运费:", bold: true, size: 24 }),
        new TextRun({ text: `\t￥${this.order.express_price}`, size: 24 })
      ]
    }));

    content.push(new Paragraph({
      children: [
        new TextRun({ text: "优惠:", bold: true, size: 24 }),
        new TextRun({ text: `\t-￥${this.order.discount_price}`, size: 24 })
      ]
    }));
    
    content.push(new Paragraph({
      children: [
        new TextRun({ 
          text: "应付总额:", 
          bold: true, 
          size: 28,
          color: "FF0000" 
        }),
        new TextRun({ 
          text: `\t￥${this.order.total_pay_price}`, 
          bold: true, 
          size: 28,
          color: "FF0000" 
        })
      ],
      border: { top: { color: "000000", size: 12 } },
      spacing: { before: 200 }
    }));

    return content;
  },

        createOrder(){
            let self = this;
            self.loading = true;
            //生成支付二维码
            HorderApi.genCode({
                    horder_id: self.horder_id,
                }).then((res) => {
                    console.log('res',res)
                    if(res.code == 1){
                        let img = res.data;
                        self.code_url = img;
                        if(img){
                            self.dialogVisible = true;
                        }
                        // localStorage.removeItem("select_product")
                    
                        // self.$message({
                        //     message: res.msg,
                        //     type: 'success'
                        // });

                        // setTimeout(() => {
                        //     self.$router.go(-1)
                        // }, 1000);
                        
                    }
                })
        }
        

        }
    };
</script>

<style>
    .tb4{
        width: 400px;
    }
    .tb7{
        width: 700px;
    }
    .tb9{
        width: 900px;
    }
    .mp20 {
        margin-top: 20px;
    }
    .part1{
        display: flex;
        align-items: center;
    }
    .setOrder {
        margin: 10px auto;
        display: flex;
        justify-content: center;
    }

    .goodsImage {
        display: flex;
        justify-content: center;
        padding: 20px 0;
    }

    .spcenter {
        margin-top: 20px;
        justify-content: center !important;
    }

    .flx {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .qname {
        margin-right: 10px;
    }
    .item{
        display: inline-block;
        margin: 0 auto;
    }
    .allheight {
        border: none !important;
    }

    .bleft {
        border-left: 1px solid #aaa !important;
        border-right: 1px solid #aaa !important;
    }
    
    .bright{
        border-right: 1px solid #aaa !important;
    }

    .tableTitle .bd {
        background: #f8f8f8;
    }

    .quotationItem {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
    }
    .word-export {
  font-family: "Microsoft YaHei", sans-serif;
}
.word-export table {
  border-collapse: collapse;
  width: 100%;
}
.word-export td, .word-export th {
  border: 1px solid #ddd;
  padding: 8px;
}
    .otable {
        border-top: 1px solid #aaa;
        border-left: 1px solid #aaa;
        border-right: none;
    }

    .bd {
        box-sizing: border-box;
        border-bottom: 1px solid #aaa;
        border-right: 1px solid #aaa;
        text-align: center;
        padding: 10px 0;
        flex-shrink: 0;
    }

    .tableTitle {
        display: flex;
        align-items: center;
    }

    .t1,
    .tb1 {
        width: 100px;
    }

    .t2,
    .tb2 {
        width: 200px;
    }

    .t3,
    .tb3 {
        width: 300px;
    }

    .t4,
    .tb4 {
        width: 400px;
    }

    .tf {
        flex: 1;
    }

    .otbody {
        display: flex;
        /* align-items: center; */
    }
</style>



// WEBPACK FOOTER //
// src/views/store/placeorder/order.vue